import Heading from "../../components/heading/heading";
import styles from "./contact.module.css";
import corporatIcon from "./icons/corporat.svg";
import bagIcon from "./icons/bag.svg";
import lightbulbIcon from "./icons/lightbulb.svg";
import chatIcon from "./icons/chat.svg";

const TELEGRAM_URL = "https://t.me/svoi_app";

type ContactAction = {
    title: string;
    description: string;
    icon: string;
};

const actions: ContactAction[] = [
    {
        title: "Хочу корпоратив",
        description: "Организуем мероприятие для компании",
        icon: corporatIcon,
    },
    {
        title: "Хочу стать партнером",
        description: "Сотрудничество для организаторов",
        icon: bagIcon,
    },
    {
        title: "Есть идея",
        description: "Как сделать приложение лучше",
        icon: lightbulbIcon,
    },
    {
        title: "Нужна помощь",
        description: "Аккаунт, жалобы, баги, вопросы",
        icon: chatIcon,
    },
];

export function ContactPage() {
    return (
        <>
            <Heading tpl="new">Связаться с нами</Heading>
            <div className={styles.wrapper}>
                <p className={styles.text}>
                    Возникли вопросы? Вы всегда можете напрямую обратиться к нам!
                </p>

                <div className={styles.actions}>
                    {actions.map((action) => (
                        <a
                            key={action.title}
                            href={TELEGRAM_URL}
                            target="_blank"
                            rel="noreferrer"
                            className={styles.action}
                        >
                            <span className={styles.iconBox}>
                                <img src={action.icon} alt="" className={styles.icon} />
                            </span>
                            <span className={styles.content}>
                                <span className={styles.title}>{action.title}</span>
                                <span className={styles.description}>{action.description}</span>
                            </span>
                        </a>
                    ))}
                </div>
            </div>
        </>
    );
}

export default ContactPage;